(function($, w) {
    if (!localStorage.getItem('user_id') || !localStorage.getItem('token')) return;
    if (w.location.pathname === '/acesso') return;

    var POPUP_ENDPOINT = '/popup/active';
    var STORAGE_KEY_PREFIX = 'popup_shown_';

    // Capture show_message NOW — the main app.js IIFE runs after this require
    // but before DOMContentLoaded, and consumes show_message for the login toast.
    // By reading it here we preserve the value for init().
    var loginTriggerPending = localStorage.getItem('show_message') === 'true';

    function getRouteName() {
        var meta = document.querySelector('meta[name="route-name"]');
        return meta ? meta.content : '';
    }

    function isPopupShown(popupId) {
        return sessionStorage.getItem(STORAGE_KEY_PREFIX + popupId) === '1';
    }

    function markPopupShown(popupId) {
        sessionStorage.setItem(STORAGE_KEY_PREFIX + popupId, '1');
    }

    function fetchPopup(trigger, route, callback, onDone) {
        var userId = localStorage.getItem('user_id') || '';
        $.ajax({
            url: POPUP_ENDPOINT,
            data: { trigger: trigger, route: route || '', user_id: userId },
            dataType: 'json'
        }).done(function(data) {
            if (data && data.id && !isPopupShown(data.id)) {
                if (typeof onDone === 'function') {
                    callback(data, onDone);
                } else {
                    callback(data);
                }
            } else {
                if (typeof onDone === 'function') onDone();
            }
        }).fail(function() {
            if (typeof onDone === 'function') onDone();
        });
    }

    function registerView(popupId) {
        var userId = localStorage.getItem('user_id');
        if (!popupId || !userId) return;
        $.ajax({
            url: '/popup/viewed',
            method: 'POST',
            data: { popup_id: popupId, user_id: userId },
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') || '' }
        }).fail(function() {});
    }

    function registerClick(popupId) {
        var userId = localStorage.getItem('user_id');
        if (!popupId || !userId) return;
        var token = $('meta[name="csrf-token"]').attr('content') || '';

        // sendBeacon sobrevive à navegação quando o CTA abre na mesma aba (_self)
        if (navigator.sendBeacon) {
            var form = new FormData();
            form.append('popup_id', popupId);
            form.append('user_id', userId);
            form.append('_token', token);
            if (navigator.sendBeacon('/popup/clicked', form)) return;
        }

        $.ajax({
            url: '/popup/clicked',
            method: 'POST',
            data: { popup_id: popupId, user_id: userId },
            headers: { 'X-CSRF-TOKEN': token }
        }).fail(function() {});
    }

    function determineLayout(data) {
        var hasMedia = data.media_type && data.media_url;
        var hasText = (data.title && data.title.trim()) || (data.content && data.content.trim());
        if (hasMedia && hasText) return 'layout-text-media';
        if (hasMedia && !hasText) return 'layout-media-only';
        return 'layout-text-only';
    }

    function renderPopup(data, onClose) {
        var $modal = $('#announcements-popup');
        var $media = $('#announcements-popup-media');
        var $title = $('#announcements-popup-title');
        var $text = $('#announcements-popup-text');
        var $cta = $('#announcements-popup-cta');
        var $ctaLink = $('#announcements-popup-cta-link');
        var $modalContent = $modal.find('.modal-content');

        $modalContent.removeClass('layout-text-only layout-media-only layout-text-media');
        $modal.removeClass('layout-text-only layout-media-only layout-text-media');
        var layout = determineLayout(data);
        $modal.addClass(layout);
        $modalContent.addClass(layout);

        // título (sempre acima de tudo) — truncar como salvaguarda para títulos antigos
        var titleText = data.title || '';
        if (titleText.length > 80) {
            titleText = titleText.substring(0, 77) + '...';
        }
        $title.text(titleText);
        if (!data.title) $title.hide(); else $title.show();

        $text.html(data.content || '');
        if (!data.content) $text.hide(); else $text.show();

        $media.empty();
        if (data.media_type && data.media_url) {
            if (data.media_type === 'video') {
                var videoUrl = data.media_url || '';
                var youtubeId = '';

                // tentar extrair ID do YouTube de vários formatos
                var ytPatterns = [
                    /youtube\.com\/watch\?v=([^&]+)/,
                    /youtube\.com\/embed\/([^?]+)/,
                    /youtu\.be\/([^?]+)/,
                    /youtube\.com\/v\/([^?]+)/
                ];
                for (var p = 0; p < ytPatterns.length; p++) {
                    var match = videoUrl.match(ytPatterns[p]);
                    if (match && match[1]) {
                        youtubeId = match[1];
                        break;
                    }
                }

                if (youtubeId) {
                    $media.html('<iframe src="https://www.youtube.com/embed/' + youtubeId + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width:100%;max-height:100%;border-radius:8px;aspect-ratio:16/9;"></iframe>');
                } else {
                    $media.html('<video controls style="max-width:100%;max-height:100%;border-radius:8px;"><source src="' + videoUrl + '"></video>');
                }
            } else {
                $media.html('<img src="' + data.media_url + '" alt="' + (data.title || '') + '" style="max-width:100%;height:auto;border-radius:8px;">');
            }
            $media.show();
        } else {
            $media.hide();
        }

        if (data.cta_text && data.cta_url) {
            $ctaLink.text(data.cta_text);
            $ctaLink.attr('href', data.cta_url);
            $ctaLink.attr('target', data.cta_target || '_blank');
            $ctaLink.off('click.popup').on('click.popup', function() {
                registerClick(data.id);
            });
            $cta.show();
        } else {
            $cta.hide();
        }

        $modal.modal('show');
        markPopupShown(data.id);
        registerView(data.id);

        if (typeof onClose === 'function') {
            $modal.one('hidden.bs.modal', function() {
                onClose();
            });
        }
    }

    function checkLoginTrigger(next) {
        if (loginTriggerPending) {
            fetchPopup('login', null, renderPopup, next);
        } else {
            if (next) next();
        }
    }

    function checkFirstAccessTrigger(next) {
        if (localStorage.getItem('first_access_completed') === 'true' && !sessionStorage.getItem('first_access_popup_checked')) {
            sessionStorage.setItem('first_access_popup_checked', '1');
            localStorage.removeItem('first_access_completed');
            fetchPopup('first_access', null, renderPopup, next);
        } else {
            if (next) next();
        }
    }

    function checkMenuAccessTrigger(next) {
        var routeName = getRouteName();
        if (routeName) {
            fetchPopup('menu_access', routeName, renderPopup, next);
        } else {
            if (next) next();
        }
    }

    function checkCategoryChangeTrigger(next) {
        var userId = localStorage.getItem('user_id') || '';
        if (!userId) { if (next) next(); return; }

        var lastGroupId = localStorage.getItem('last_group_id');
        var handled = false;

        $.ajax({
            url: '/popup/user-category',
            data: { user_id: userId },
            dataType: 'json'
        }).done(function(data) {
            if (!data || data.group_id === undefined || data.group_id === null) return;

            var currentGroupId = String(data.group_id);

            // se há um valor anterior e é diferente do atual → houve mudança de categoria
            if (lastGroupId !== null && lastGroupId !== currentGroupId) {
                handled = true;
                localStorage.setItem('last_group_id', currentGroupId);
                fetchPopup('category_change', null, renderPopup, next);
                return;
            }

            localStorage.setItem('last_group_id', currentGroupId);
        }).fail(function() {}).always(function() {
            if (!handled && next) next();
        });
    }

    function init() {
        checkLoginTrigger(function() {
            checkFirstAccessTrigger(function() {
                checkMenuAccessTrigger(function() {
                    checkCategoryChangeTrigger();
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})(jQuery, window);